import React from "react";
import { Link } from "react-router-dom";
import { navMenu } from "../../data";
import { useTranslation } from "react-i18next";

const Navigation = () => {
  const { t } = useTranslation();
  return (
    <nav className="mainmenu__nav">
      <ul className="mainmenu">
        {navMenu.map((val, index) => {
          return (
            <li key={index}>
              <Link to={process.env.PUBLIC_URL +val.url}>{t(val.title)}</Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Navigation;
